import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { ProposalDocument } from "@/components/proposal-document";
import { getPublicProposal } from "@/lib/proposals.functions";
import { normalizeLocale, proposalDocStrings, proposalStrings } from "@/lib/proposals-i18n";

export const Route = createFileRoute("/p_/$token/contract")({
  ssr: false,
  component: ContractPage,
  head: () => ({
    meta: [
      { title: "Service agreement · the Vibing Company®" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

function ContractPage() {
  const { token } = Route.useParams();
  const fetchProposal = useServerFn(getPublicProposal);
  const { data, isLoading } = useQuery({
    queryKey: ["public-proposal-contract", token],
    queryFn: () => fetchProposal({ data: { token } }),
    retry: false,
  });

  const locale = normalizeLocale(data?.language);
  const t = proposalStrings(locale);
  const d = proposalDocStrings(locale);

  useEffect(() => {
    if (data) document.title = `${data.number} · ${data.title}`;
  }, [data]);

  if (isLoading) return <p className="p-10 text-sm">{t.contractPreparing}</p>;
  if (!data) return <p className="p-10 text-sm">{t.contractUnavailable}</p>;

  return (
    <div className="min-h-screen bg-neutral-200 py-10 print:bg-white print:py-0">
      <div className="pdf-toolbar mx-auto mb-6 flex max-w-[210mm] flex-wrap items-center justify-between gap-4 px-4">
        <a
          href={`/p/${token}`}
          className="text-xs text-neutral-700 underline underline-offset-4 hover:text-black"
        >
          ← {d.docBack}
        </a>
        <div className="flex items-center gap-4">
          <p className="hidden text-[11px] text-neutral-600 sm:block">{d.docPrintHint}</p>
          <button
            type="button"
            onClick={() => window.print()}
            className="rounded-full bg-black px-5 py-2.5 text-sm font-medium text-white transition-[opacity,scale] hover:opacity-90 active:scale-[0.97]"
          >
            {d.docDownload}
          </button>
        </div>
      </div>

      <main className="pdf-sheet mx-auto w-[210mm] max-w-full">
        <ProposalDocument proposal={data} locale={locale} />
      </main>

    </div>
  );
}
